module.exports = __webpack_public_path__ + "static/img/05-korbion.f326ae2b.jpg";